export default __webpack_public_path__ + "static/media/HV_Icones_Staging.77108292.svg";